import { directionAPI } from '@/api'
import { SortOrder } from '@pages/CoursesCatalog/components/HorizontalSorting/useHorizontalSorting'

export const fetchCourses = async ({
  folder,
  subFolder,
  sorting,
}: {
  folder?: number
  subFolder?: number
  sorting?: {
    id: string
    order: SortOrder
  }
}): Promise<ICourse[]> => {
  try {
    const filters = []

    filters.push(`[view][eq]=1`)
    if (folder) filters.push(`[filter_id][eq]=${folder}`)
    if (subFolder) filters.push(`[sub_folder_id][eq]=${subFolder}`)
    if (sorting) {
      filters.push(`[filter_name]=${sorting?.id}`)
    }
    if (sorting && sorting?.order !== 'none') {
      filters.push(`[filter_sort]=${sorting?.order}`)
    }

    const res = await directionAPI.getCatalog({
      filter: filters,
      expand: ['directionTariffs'],
    })

    const courses = (res?.data?.data as ICourse[]) ?? []

    if (!sorting) {
      courses.sort((a, b) => {
        if (a.sorting === null) return 1
        if (b.sorting === null) return -1
        return a.sorting - b.sorting
      })
    }

    return courses
  } catch (error) {
    console.error('Ошибка загрузки курсов:', error)
    return []
  }
}
